
import { UseImageFiltersReturn } from './types';
import { useImageFiltersCore } from './use-image-filters-core';

/**
 * Main hook for image filter functionality
 * This is a wrapper around useImageFiltersCore that can be extended 
 * with additional functionality if needed in the future
 */
export const useImageFilters = (): UseImageFiltersReturn => {
  return useImageFiltersCore();
};
